import { createContext, useReducer } from "react";
import moment from "moment-timezone"; // Import moment-timezone

// contex to render the updated data without refresh
// which means all components now have an access to the WP Sitecontext
export const AllOrdersContext = createContext();

export const allOrdersReducer = (state, action) => {
  switch (action.type) {
    case "SET_ALL_ORDERS":
      // Convert all orders to Krakow time zone
      const ordersWithKrakowTime = action.payload.map(order => ({
        ...order,
        createdAt: moment(order.createdAt).tz(process.env.REACT_APP_TIME_ZONE).format('YYYY-MM-DD HH:mm:ss'),
      }));
      return {
        allOrders: ordersWithKrakowTime
      };
    case "UPDATE_ORDERS":
      // Convert updated order time to Krakow time zone
      const updatedOrder = {
        ...action.payload,
        createdAt: moment(action.payload.createdAt).tz(process.env.REACT_APP_TIME_ZONE).format('YYYY-MM-DD HH:mm:ss'),
      };
      return {
        allOrders: state.allOrders.map((order) =>
          order._id === updatedOrder._id ? updatedOrder : order
        ),
      };
    default:
      return state;
  }
};

export const AllOrdersContextProvider = ({ children }) => {
  const [state, allOrdersDispatch] = useReducer(allOrdersReducer, {
    allOrders: null,
  });
  return (
    <AllOrdersContext.Provider value={{ ...state, allOrdersDispatch }}>
      {children}
    </AllOrdersContext.Provider>
  );
};